export enum BUDGET_ACTIONS {
	CREATE = "CREATE",
	UPDATE = "UPDATE",
}

export enum FORM_ACTIONS {
	CREATE = "CREATE",
	UPDATE = "UPDATE",
}
